import React from "react";

import { QueryBuilderContext } from "./types";

import {
  defaultCombinators,
  defaultLabels,
  defaultOperators,
} from "./defaults";

export default React.createContext<QueryBuilderContext>({
  dispatchAction: () => ({}),
  askAction: () => ({}),
  selectLocation: () => ({}),
  attributes: {},
  operators: defaultOperators,
  combinators: defaultCombinators,
  maxDepth: 1,
  labels: defaultLabels,
  initialTouched: false,
});
